import React, { FC, useCallback, useEffect } from 'react'
import { Card, CardInner, ContractCardBody, ContractCardTitle } from 'components/Card'
import { Spacer } from 'components/Utility'
import { FlexRow } from 'components/Flex'
import { TextButton } from 'components/Button'
import { useDispatch, useSelector } from 'react-redux'
import { push } from 'connected-react-router'
import { State } from 'index'
import { getCard, getStripePaymentMethodId } from 'reducks/shop/selectors'
import { fetchShop, retrieveCard } from 'reducks/shop/operations'
import { zeroPadding } from 'lib/helper'
import { getShopRef } from 'reducks/store/selectors'

const ContractInformationCard: FC = React.memo(() => {
  const dispatch = useDispatch()

  const shopRef = useSelector((state: State) => getShopRef(state))
  const card = useSelector((state: State) => getCard(state))
  const stripePaymentMethodId = useSelector((state: State) => getStripePaymentMethodId(state))

  const goToEditCard = useCallback(() => {
    dispatch(push('/contract/card'))
  }, [dispatch])

  useEffect(() => {
    if (!shopRef) return
    dispatch(fetchShop(shopRef.id))
  }, [shopRef])

  useEffect(() => {
    if (!stripePaymentMethodId || stripePaymentMethodId === '') return
    dispatch(retrieveCard(stripePaymentMethodId))
  }, [stripePaymentMethodId])

  return (
    <Card>
      <CardInner>
        <Spacer size={4} />
        <ContractCardTitle title={'請求情報'} />
        <Spacer size={20} />
        <ContractCardBody label={'カード番号'} value={typeof card !== 'undefined' ? `●●●● ${card.last4}` : ''} />
        <ContractCardBody
          label={'有効期限'}
          value={typeof card !== 'undefined' ? `${card.exp_year}/${zeroPadding(card.exp_month)}` : ''}
        />
        <Spacer size={20} />
        <FlexRow justifyContent={'center'}>
          <TextButton label={'請求情報を編集'} onClick={goToEditCard} />
        </FlexRow>
        <Spacer size={4} />
      </CardInner>
    </Card>
  )
})

export default ContractInformationCard
